<template>
    <div 
      class="map-piece"
      :style="{
        gridColumn: `${record.column - 1} / ${record.column}`,
        gridRow: `${record.row} / ${record.row + 1}`,
      }"
      @mouseenter="recordMouseover"
      @mouseleave="recordMouseout"
    >
    <router-link 
      :to="{
        name: 'Record',
        params: {
          recordName: record.code,
          record: record
        }
      }"
    >
      <img
        :src="`https://storage.googleapis.com/cartografiadigital/records_icons/${record.code}.png`"
        class="record-img"
        :class="{
          selected: selected,
          softOpacity: softOpacity,
        }"
      >

      <v-popover
        :open="show"
        :delay="{show: 500}"
        :placement="record.row < 20 ? 'bot' : 'top'"
        offset="50"
      >
        <template slot="popover">
          <section
            class="popover-content"
          >
            <div class="title">{{ record.title }}</div>
            <div class="author-and-year">
              <span>{{record.author[0]}}</span><span>{{record.year ? `, ${record.year}` : ''}}</span>
            </div>
            <div class="message">
              Click para más información  
            </div>
          </section>
        </template>
      </v-popover>


    </router-link>
    </div>
</template>

<script>

export default {
  name: 'MapPiece',
  props: [
    'record',
    'hoveredType',
    'hoveredValue',
    'selectedType',
    'selectedValue',
    'mouseover',
    'hoveredRecord',
    'selection',
  ],
  data() {
    return {
      show: false,
    }
  },
  methods: {
    recordMouseover(){
      if (this.selected){
        this.$emit('recordMouseover', this.record);
        this.show = true;
      }
    },
    recordMouseout(){
      this.$emit('recordMouseout');
      this.show = false;
      this.softOpacity = false;
    },
  },
  computed: {
    selected: function() {
        if (this.selection.country && (this.selection.country !== this.record.country.normalize("NFD").replace(/[\u0300-\u036f]/g, ""))){
          return false;
        }
        if (this.selection.genre && (this.selection.genre !== this.record.genre)){
          return false;
        }
        if (this.selection.technique && !this.record.techniques.includes(this.selection.technique)) {
          return false
        }
        if (this.selection.format && !this.record.format.includes(this.selection.format)) {
          return false
        }
        if (this.selection.years && ((this.selection.years[0] > this.record.year) || (this.selection.years[1] < this.record.year))){
          return false
        }
        if (this.selection.searchString && !(
            this.record.title.toLowerCase().includes(this.selection.searchString.toLowerCase()) ||
            this.record.author.some(author => author.toLowerCase().includes(this.selection.searchString.toLowerCase()))
          )) {
          return false
        }
        return true;
    },
    imgUrl: function() {
      return this.record.genre === "Poesía" ?
      "poetry" : this.record.genre === "Narrativa" ?
      "narrative" : "other"
    },
    softOpacity: {
      get: function() {
        return this.selected && this.hoveredRecord && (this.record.code !== this.hoveredRecord);
      },
      set: function(val) {
        return val;
      }
    }
  }
}
</script>

<style scoped>

  .record-img {
    opacity: 0.25;
    transition: opacity 0.2s;
  }

  .selected {
    opacity: 1;
  }

  .softOpacity {
    opacity: 0.5;
  }

  .map-piece {
    width: 100%;
    /* height: 100%; */
  }

  .popover-content {
    /* margin-top: 20px; */
    width: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .popover-content .title {
    font-family: var(--vesper);
    font-size: 24px;
    font-weight: 900;
    text-align: center;
  }

  .popover-content .author-and-year {
    font-family: var(--vesper);
    font-size: 20px;
    text-align: center;
  }

  .popover-content .message {
    font-family: var(--courier);
    font-size: 12px;
    font-style: italic;
    text-align: center;
  }

  .v-popover {
    height: 0%;
  }

</style>